// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1i63k","signatureBlock":"Footer_signatureBlock__2rjqN","signature":"Footer_signature__1_E9c"};